import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'minimumPensionEstimator',
  storage,
};

export default persistConfig;